export default __webpack_public_path__ + "static/media/oncology.c8b6f068.jpg";